// extracted by mini-css-extract-plugin
export default {"header":"Header_header__VCAhQ","string":"Header_string__hu2Rc","socials":"Header_socials__4YZTP"};